import { useEffect } from 'react';

export const useFadeObserver = ref => {
  useEffect(() => {
    const fadeObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !entry.target.classList.contains('on-screen')) {
            entry.target.classList.add('on-screen');
            fadeObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '20px' }
    );

    fadeObserver.observe(ref.current);

    return () => fadeObserver.unobserve(ref.current);
  }, [ref]);
};
